export default (() =>
{
  const cartHeaderContainerId = '#cart-header-container'
  const cartOffcanvasContentId = 'cart-offcanvas-content'
  const cartOffcanvasContainerId = 'cart-header-container-offcanvas'

  const cartSidepanelOffcanvasContentId = 'order-preview-content';
  const cartSidepanelOffcanvasContainerId = 'order-preview-container';

  function copyCartContent()
  {
    let cartContentElement = document.getElementById(cartOffcanvasContentId)
    let cartOffcanvasContainer = document.getElementById(cartOffcanvasContainerId)

    if (!cartContentElement || !cartOffcanvasContainer)
      return

    let cartContent = cartContentElement.innerHTML

    if (cartContent.length === 0)
      return

    cartOffcanvasContainer.innerHTML = cartContent

    cartContentElement.innerHTML = ""
  }

  function copyCartSidepanelContent()
  {
    let cartContentElement = document.getElementById(cartSidepanelOffcanvasContentId)
    let cartOffcanvasContainer = document.getElementById(cartSidepanelOffcanvasContainerId)

    if (!cartContentElement || !cartOffcanvasContainer)
      return

    let cartContent = cartContentElement.innerHTML

    if (cartContent.length === 0)
      return

    cartOffcanvasContainer.innerHTML = cartContent

    cartContentElement.innerHTML = ""
  }

  copyCartContent()
  copyCartSidepanelContent();

  document.addEventListener("onElementContentChanged", event =>
  {
    if (event.detail.target !== cartHeaderContainerId)
      return;

    copyCartContent();
  });

  var searchBox = document.getElementById("search-box");

  document.addEventListener("onAutocompleteChanged", async event =>
  {
    if (!searchBox)
      return;

    await images.load();

    setTimeout(function ()
    {
      var headerHeight = searchBox.querySelector(":scope .offcanvas-header").clientHeight;
      var bodyHeight = searchBox.querySelector(":scope .autocomplete-container").clientHeight;

      var body = searchBox.querySelector(":scope .offcanvas-body");
      var computedStyles = window.getComputedStyle(body);

      var padding = parseInt(computedStyles.getPropertyValue("padding-top")) + parseInt(computedStyles.getPropertyValue("padding-bottom"));

      searchBox.style.height = (headerHeight + bodyHeight + 2 + padding) + "px";
    }, 50);
  });
})()
